import React from 'react';
import { Navbar } from 'reactstrap';
import { shallowEqual, useSelector } from 'react-redux';

import DashboardStats from './DashboardStats';
import SidebarIcon from './SidebarIcon';
import hasPermission from '../Shared/hasPermission';
import Logo from './Logo';
import UserDropdown from './UserDropdown';

const Header = (props) => {
    const { isAuthenticated, login } = props;

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canSeeDash = hasPermission('Dashboard', permissions);

    return (
        <Navbar
            className="fixed-top w-100 p-1 px-2 d-flex justify-content-around bg-light"
            light
            expand="md">
            {permissions.length > 0 && (
                <SidebarIcon isAuthenticated={isAuthenticated} />
            )}
            <Logo />
            {isAuthenticated && canSeeDash && <DashboardStats />}

            {isAuthenticated && (
                <UserDropdown isAuthenticated={isAuthenticated} login={login} />
            )}
        </Navbar>
    );
};

export default React.memo(Header);
